var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"TheInformation"}},[_c('header',{staticClass:"information_title"},[_vm._v("基本情報")]),_c('main',{staticClass:"information_content"},_vm._l((_vm.informations),function(item){return _c('div',{key:item.title,staticClass:"information_content_item"},[_c('a',{staticClass:"item_container",on:{"click":() =>
            _vm.handleTransferScreen({
              isToExternalServer: item.isToExternalServer,
              path: item.path,
            })}},[_c('div',[_c(item.icon,{tag:"component"}),_c('span',{staticClass:"item_title"},[_vm._v(_vm._s(item.title))])],1),_c('IconArrowRight')],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }